// Auth links
export const SIGN_IN = "signin";
export const FORGOT_PASSWORD = "forgot-password";
export const RESET_PASSWORD = "reset-password";
export const SET_PASSWORD = "set-password";
export const SET_PASSWORD_SUCCESS = "password-success";
export const COMPLETE_ACCOUNT = "complete-account";
export const HOMEPAGE = "/";



// Dashboard links
export const DASHBOARD_BASE = "/admin";
export const DASHBOARD = DASHBOARD_BASE + "/dashboard";

// COMMON 
export const NOT_FOUND = "/404";
